// extracted by mini-css-extract-plugin
export default {"header":"HeaderInner_header__xDeqQ","header-wrapper":"HeaderInner_header-wrapper__FF4Mw","logo-wrapper":"HeaderInner_logo-wrapper__pouwX"};